import "whatwg-fetch";

const BASE_URL = "/api";

function checkStatus(response) {
  // SSO redirects
  let redirect = response.headers.get("auth-redirect");
  if (redirect) {
    window.location = redirect;
  }

  if (response.ok) {
    return response;
  } else {
    const error = new Error(`HTTP Error ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
    console.log(error); // eslint-disable-line no-console
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}

export function post(endpoint, body = {}, basePath = BASE_URL) {
  const method = "POST";
  const headers = Object.assign(
    {},
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/json"
      }
    },
    { method, body: JSON.stringify(body) },
    { credentials: "include" }
  );

  return fetch(`${basePath}/${endpoint}`, headers)
    .then(checkStatus)
    .then(parseJSON);
}

export function get(endpoint, params = {}, basePath = BASE_URL, body = {}) {
  const headers = Object.assign(
    {},
    {
      headers: {
        accept: "application/json",
        "Content-Type": "text/plain"
      }
    },
    { credentials: "include" }
  );
  const urlParams = new URLSearchParams(Object.entries(params));

  return fetch(`${basePath}/${endpoint}?${urlParams}`, headers)
    .then(checkStatus)
    .then(parseJSON);
}

export function put(endpoint, body = {}, basePath = BASE_URL) {
  const method = "PUT";
  const headers = Object.assign(
    {},
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/json"
      }
    },
    { method, body: JSON.stringify(body) },
    { credentials: "include" }
  );

  return fetch(`${basePath}/${endpoint}`, headers)
    .then(checkStatus)
    .then(parseJSON);
}

export function del(endpoint, body = {}, basePath = BASE_URL) {
  const method = "DELETE";
  const headers = Object.assign(
    {},
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/json"
      }
    },
    { method, body: JSON.stringify(body) },
    { credentials: "include" }
  );

  return fetch(`${basePath}/${endpoint}`, headers)
    .then(checkStatus)
    .then(parseJSON);
}

export function getXml(url) {
  if (!url) {
    return null;
  }

  return (
    fetch(url)
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error(`${response.status}: ${response.statusText}`);
      })
      // replaceAll() hack until backend doesn't support source-id instead of item-id
      .then((xmlString) =>
        new window.DOMParser().parseFromString(
          xmlString.replaceAll("item-id", "source-id"),
          "text/xml"
        )
      )
      .then((data) => {
        return data;
      })
  );
}



// WEBPACK FOOTER //
// ./client/apis/utils.js